var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EChart',{staticClass:"mt-3",attrs:{"card":"","options":_vm.chartOptions,"header":_vm.$t('sales'),"error":_vm.requestChart.getError(),"loading":_vm.requestChart.getLoading(),"type":"time"}})
}
var staticRenderFns = []

export { render, staticRenderFns }